import React, { useRef, useState, useEffect, useCallback } from "react";
import { FiLoader } from "react-icons/fi";
import swal from "sweetalert";
import * as Yup from "yup";
import { Form } from "@unform/web";
import { apiPHP } from "../../services/api";
import Modal from "../Modal";
import { Input, InputMask } from "../Form";

import {
  Container,
  FormGroup,
  InputGroup,
  Title,
  SubmitButton,
  ModalContent,
  Checkbox,
  ModalTrigger,
} from "./styles";

const INITIAL_FORMDATA = {
  nome: "Felipe Gangrel",
  celular: "(21) 98989-9898",
  cpf: "123.123.123-12",
  email: "felipefrog@gmail.com",
  email_confirm: "felipefrog@gmail.com",
  senha: "123456",
  senha_confirm: "123456",
  instagram: "felipegangrel",
};

function Signup() {
  const form = useRef();
  const concordoRef = useRef();

  const [formdata, setFormdata] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormdata((state) => ({ ...state, [name]: value }));
  }

  async function handleSubmit() {
    try {
      if (!formdata.concordo) {
        swal(
          "Ops",
          "Você precisa ler e concordar com as Regras do Desafio",
          "warning"
        );
        return false;
      }

      form.current.setErrors({});
      const schema = Yup.object().shape({
        nome: Yup.string().required("Obrigatório"),
        celular: Yup.string().required("Obrigatório"),
        cpf: Yup.string().required("Obrigatório"),
        email: Yup.string().email("E-mail inválido").required("Obrigatório"),
        instagram: Yup.mixed(),
        email_confirm: Yup.string()
          .email("E-mail inválido")
          .required("Obrigatório")
          .test("email-match", "Confirme seu email", function (value) {
            return this.parent.email === value;
          }),
        senha: Yup.string().required("Obrigatório"),
        senha_confirm: Yup.string()
          .required("Obrigatório")
          .test("senha-match", "Confirme sua senha", function (value) {
            return this.parent.senha === value;
          }),
      });

      await schema.validate(formdata, {
        abortEarly: false,
      });

      setLoading(true);

      const post = {
        nome: formdata.nome,
        cpf: formdata.cpf,
        celular: formdata.celular,
        email: formdata.email,
        senha: formdata.senha,
        instagram: formdata.instagram,
      };

      const { data: response } = await apiPHP.post("desafio21/cadastrar", post);

      setLoading(false);
      if (response.success) {

        swal(
          "Sucesso!",
          "Clique no botão abaixo para realizar o pagamento do Desafio! Após a confirmação do pagamento, entraremos em contato com você pelo celular informado no seu cadastro, para que você seja incluído no nosso grupo do Telegram, receba nosso E-book e as orientações de como realizar o Desafio!",
          "success",
          {
            button: "Pagar com PayPal",
            defeat: true,
          }
        ).then(() => {
          window.open(response.pedidoLink);
        });
      } else {
        swal("Ops", response.message, "error");
      }
    } catch (errors) {
      handleErrors(errors, form);
    }
  }

  function handleErrors(errors, formRef) {
    const validationErrors = {};
    if (errors instanceof Yup.ValidationError) {
      errors.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });
      formRef.current.setErrors(validationErrors);
      swal("Ops!", "Por favor, verifique seu formulário de cadastro", "error");
    }
  }

  function renderModalRegras() {
    return (
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <ModalContent>
          <h3>REGRAS DO DESAFIO 21 DIAS</h3>
          <p>
            Esse Desafio tem o objetivo de ajudar você a iniciar um Estilo de
            Vida Saudável e consciente e para isso iremos disponibilizar dicas
            de exercícios físicos, aulas de treinamento em grupo ao vivo e
            online orientadas pela Educadora Física e Fisioterapeuta Lívia
            Mietherhofer, instruções, orientações e esclarecimentos que como
            mudar os hábitos serão divididos com você ao longo de 21 dias. Para
            o bom desenvolvimento da dinâmica do Desafio, será formado um grupo
            exclusivo no telegram, onde será nosso meio de comunicação para
            disponibilizar, somente os administradores poderão enviar mensagem,
            todas as aulas e os materiais da nossa imersão online, para ter
            resultado no desafio:
          </p>
          <p className="rule">
            1) Comprometa-se com você!!! Tente seguir ao máximo as dicas e os
            desafios propostos; Lembre-se o maior desafio é você consigo mesmo!
            Devemos sempre nos compararmos o resultado com nós mesmos!
          </p>
          <p className="rule">
            2) Interaja com o grupo nos encontros pelo zoom, na rede social, a
            sua vitória ou a sua dificuldade pode ser igual ao do colega do
            grupo;{" "}
          </p>
          <p className="rule">
            3)Todos os dias serão enviados no grupo um ou mais DESAFIOS que
            deverão ser obedecidos rigorosamente para que o participante alcance
            100% dos resultados. Para isso, deve-se observar o que cada DESAFIO
            irá solicitar em relação à uma postagem no Instagram (no perfil
            pessoal de cada participante), em relação às marcações, às hashtags
            ou a uma tarefa proposta.
          </p>
          <p className="rule">
            4) As postagens somente serão validadas se forem postadas no mesmo
            dia em que foi apresentado o Desafio do dia, ou seja, até às 23:59h.
            À partir de 00:00h do dia seguinte a postagem será invalidada.
          </p>
          <p className="rule">
            5) É necessário que cada participante tenha como se pesar e medir a
            sua altura e registrar em vídeo essas medições. Como realizar os
            REGISTROS INICIAIS e a maneira correta de gravar os vídeos desses
            registros será enviado.
          </p>
          <p className="rule">
            6)Todos os participantes deverão enviar 4 fotos de corpo inteiro com
            roupa favorável (short e top ) para visualizarmos as mudanças no
            decorrer do desafio e ao final do desafio,
          </p>
          <p className="rule">
            7) Todos os participantes deverão possuir uma conta ativa no
            Instagram e a mesma deverá ser “pública” para que seja possível que
            possamos verificar os posts solicitados no Desafio.
          </p>
          <p className="rule">
            8) Política de Cancelamento e Reembolso: Fique tranquilo(a)! Caso
            tenha algum imprevisto antes do início do programa e não possa
            participar, nossa política de reembolso é bastante flexível.
            Aceitamos cancelamentos até 2 dias antes do início do programa, com
            REEMBOLSO INTEGRAL do pagamento sem nenhum questionamento. Após essa
            data não realizamos o reembolso, mas tampouco você irá perder o seu
            investimento. Você poderá colocar outra pessoa em seu lugar ou
            garantir sua vaga para o próximo Desafio! Contudo, depois de
            iniciado o programa, o participante que porventura desistir de
            continuar não será ressarcido em hipótese alguma do valor investido.
          </p>
        </ModalContent>
      </Modal>
    );
  }

  const setFormdataConcordoCB = useCallback(() => {
    if (concordoRef.current) {
      const { checked: concordo } = concordoRef.current;
      setFormdata((state) => ({ ...state, concordo }));
    }
  }, [concordoRef.current, concordoRef.current?.checked, setFormdata]);

  useEffect(() => {
    setFormdataConcordoCB();
  }, [setFormdataConcordoCB]);

  return (
    <Container>
      <Form ref={form} onSubmit={handleSubmit}>
        <FormGroup>
          <Title>Informações</Title>
          <InputGroup>
            <Input
              name="nome"
              label="Nome Completo:"
              value={formdata.nome}
              onChange={handleChange}
            />
          </InputGroup>
          <InputGroup>
            <Input
              name="instagram"
              label="Instagram:"
              value={formdata.instagram}
              onChange={handleChange}
            />
          </InputGroup>
          <InputGroup>
            <InputMask
              name="celular"
              label="Celular:"
              type={(formdata?.celular?.length > 14 && "celular") || "telefone"}
              value={formdata.celular}
              onChange={handleChange}
            />
            <InputMask
              name="cpf"
              label="CPF:"
              type="cpf"
              value={formdata.cpf}
              onChange={handleChange}
            />
          </InputGroup>
        </FormGroup>
        <Title>Dados de Acesso</Title>
        <InputGroup>
          <Input
            name="email"
            type="email"
            label="E-mail:"
            value={formdata.email}
            onChange={handleChange}
          />
          <Input
            name="email_confirm"
            type="email"
            label="Confirmar e-mail:"
            value={formdata.email_confirm}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Input
            name="senha"
            label="Senha:"
            type="password"
            value={formdata.senha}
            onChange={handleChange}
          />
          <Input
            name="senha_confirm"
            label="Confirmar senha:"
            type="password"
            value={formdata.senha_confirm}
            onChange={handleChange}
          />
        </InputGroup>

        <Checkbox>
          <label htmlFor="concordo">
            <input
              ref={concordoRef}
              id="concordo"
              type="checkbox"
              name="concordo"
              onChange={handleChange}
            />
            <span className="label">
              Declaro que li e aceito as{" "}
              <ModalTrigger onClick={() => setModalOpen(true)}>
                Regras do Desafio
              </ModalTrigger>
            </span>
          </label>
        </Checkbox>

        <SubmitButton type="submit">
          {loading ? (
            <FiLoader size={20} className="icon-spin" />
          ) : (
            "Criar conta"
          )}
        </SubmitButton>
      </Form>

      {renderModalRegras()}
    </Container>
  );
}

export default Signup;
